import { Components, Theme } from '@mui/material';

const MuiDivider: Components<Theme>['MuiDivider'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderColor: theme.palette.grey[300],
    }),
  },
};

export default MuiDivider;
